import { toast as sonnerToast } from "sonner";

/** Show one toast at a time on the Jivandhara site (top-center). */
function show(type: "success" | "error" | "info", message: string) {
  sonnerToast.dismiss();
  sonnerToast[type](message);
}

export const projectToast = {
  success: (message: string) => show("success", message),
  error: (message: string) => show("error", message),
  info: (message: string) => show("info", message),
};
